import { getAttributionSnapshot } from '../attribution';

const API_BASE = process.env.REACT_APP_API_URL || '';

/**
 * Persist attribution on the user's Firestore profile after signup/login.
 * @param {import('firebase/auth').User} user
 * @param {'signup'|'login'} touchType
 */
export async function syncAttributionTouch(user, touchType) {
  if (!user || !API_BASE) return;
  try {
    const token = await user.getIdToken();
    const attribution = getAttributionSnapshot();
    await fetch(`${API_BASE}/api/account/attribution/touch`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ touchType, attribution }),
    });
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[cognidoor:attribution] touch sync failed', err);
    }
  }
}
